import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { FileUpload } from "../core/components/fileUpload";
import { Helper } from "../core/util/helper";
import { StyleAppProps } from "./style";
import React from "react";
export default class EditLogo extends React.Component<StyleAppProps, { file: any }> {
    private allowedFormats = ["jpg", "png", "svg", "gif", "jpeg"];
    constructor(props) {
        super(props);
        this.state = {
            file: null
        };
    }

    private upLoad = (file: any) => {
        const formData = new FormData();
        formData.append("file", file.rawFile);
        HTTPService.post<JsonResultClass>("Style/UpdateLogo", formData).then(result => {
            this.update(result, () => { this.setState({ file: null })})
        });
    }

    private update = (result: JsonResultClass, callBack: () => void = null) => {
        if (Helper.hasValue(result.AdditionalData) && Helper.hasValue(result.AdditionalData.customFileCreated) && result.AdditionalData.customFileCreated) {
            NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.GeneralSettings.Style.ApplicationRestarted"));
            setTimeout(() => {
                document.getElementById('logout-form__trigger').click();
            }, 1000);
        } else {
            if (result.Code == 1) {
                NotificationHelper.showErrorMessage(result.Message);
            } else {
                location.reload();
            }
        }
        if (Helper.hasValue(callBack)) {
            callBack();
        }
    }

    private validateFile = (file: any) => {
        return (this.allowedFormats.indexOf((file.extension as string).toLowerCase().replace(".", "")) > -1);
    }

    render() {
        return (
            <>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: (Helper.hasValue(this.state.file) ? "250px" : "200px") }}>
                    <FileUpload
                        style={{ width: "383px", marginLeft: "5px" }}
                        upload={this.upLoad}
                        validate={this.validateFile}
                        uploadButton={true}
                        onFileChange={(file) => { this.setState({ file: file }); }}
                    />
                    <div id="innosoft-logo-400"></div>
                </div>
            </>
        );
    }
};

